export * from './palette.interface';
export * from './full-color.interface';
